import { CreateCompanyActionsEnum, ICreateCompanyState } from './types'

export const initialState: ICreateCompanyState = {
  createUser: {
    name: '',
    id: '',
    mail: '',
  },
  createCompany: {
    contactEmail: undefined,
    name: undefined,
    country: undefined,
  },
  currentStep: 'connectPlatform',
  isLoading: true,
  isCreateCompanyLoader: false,
  agreeToTerms: false,
  flow: 'B_2025_06',
}

export const reducer = (state: ICreateCompanyState, action) => {
  switch (action.type) {
    case CreateCompanyActionsEnum.setCurrentStep: {
      const newState = {
        ...state,
        currentStep: action.payload,
      }

      return newState
    }
    case CreateCompanyActionsEnum.setCreateCompanyDetails: {
      const newState = {
        ...state,
        createCompany: {
          ...state.createCompany,
          contactEmail: action.payload.contactEmail,
          name: action.payload.name,
          country: action.payload.country,
          state: action.payload.state,
          hasUnlimitedDays: action.payload.hasUnlimitedDays,
          daysPerYear: action.payload.daysPerYear,
          announceNewUsers: action.payload.announceNewUsers,
          surveyQuestionMainOption: action.payload.surveyQuestionMainOption,
          ...(action.payload.surveyQuestionSubOption ? { surveyQuestionSubOption: action.payload.surveyQuestionSubOption } : {}),
        },
        agreeToTerms: action.payload.agreeToTerms,
      }

      return newState
    }
    case CreateCompanyActionsEnum.setCreateUser: {
      const newState = {
        ...state,
        createUser: action.payload,
      }

      return newState
    }
    case CreateCompanyActionsEnum.isCreateCompanyLoader: {
      const newState = {
        ...state,
        isCreateCompanyLoader: action.payload,
      }

      return newState
    }
    case CreateCompanyActionsEnum.setCreateUserName: {
      const newState = {
        ...state,
        createUser: {
          ...state.createUser,
          name: action.payload,
        },
      }

      return newState
    }
    case CreateCompanyActionsEnum.setFlow: {
      const newState = {
        ...state,
        flow: action.payload,
      }

      return newState
    }
    case CreateCompanyActionsEnum.setPlan: {
      const newState = {
        ...state,
        createCompany: {
          ...state.createCompany,
          plan: action.payload,
        },
      }

      return newState
    }
    default:
      throw new Error()
  }
}
